import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { httpInterceptorProviders } from './app/core/services/interceptor';
import { environment, environmentConfig } from './environments/environment';
import { getConfig } from './environments/environment-config-loader';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

if (environment.production) {
  enableProdMode();
}

getConfig().then(config => {

  bootstrapApplication(AppComponent, {
    providers: [
      { provide: environmentConfig, useValue: config },
      provideHttpClient(httpInterceptorProviders),
      provideNativeDateAdapter(),
      {
        provide: APP_BASE_HREF,
        useValue: config.baseHref,
        deps: [environmentConfig],
      },
      provideRouter(routes),
      provideAnimations(),
      provideToastr({maxOpened: 5})
    ]
  }).catch(err => console.error(err));
});
